import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewOptionQueryModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewOptionQueryModal: React.FC<ViewOptionQueryModalProps> = ({ open, onClose }) => {
  const { selectedQuery, loading } = useAppSelector((state) => state.optionQueries);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Detalle de Query de Opciones</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedQuery ? (
          <Box sx={{ mt: 2 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Query Key
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedQuery.queryKey}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Descripción
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedQuery.description}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                SQL
              </Typography>
              <Box
                component="pre"
                sx={{
                  mb: 2,
                  p: 2,
                  backgroundColor: '#1e1e1e',
                  color: '#d4d4d4',
                  borderRadius: 1,
                  overflow: 'auto',
                  fontSize: '0.85rem',
                  fontFamily: '"Fira Code", "Consolas", "Monaco", monospace',
                  maxHeight: 300,
                }}
              >
                {selectedQuery.sql}
              </Box>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Creación
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedQuery.createdAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Creado Por
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedQuery.createdBy || '(N/A)'}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Actualización
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedQuery.updatedAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Actualizado Por
              </Typography>
              <Typography variant="body1">
                {selectedQuery.updatedBy || '(N/A)'}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography>No hay query seleccionada</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewOptionQueryModal;
